module.exports = __webpack_public_path__ + "images/background-red-1-a85d7b51e1562c62bbe33c80bb8e20b6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/background-red-1.svg
// module id = 7
// module chunks = 0